import React, { useState, useEffect, useRef } from 'react'
import { Rating } from 'react-simple-star-rating';
import CustomInput from '../../../../Utility/Components/CustomInput';
import ErrorBoundary from 'antd/es/alert/ErrorBoundary';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import EmojiContent from '../../../../Utility/Components/EmojiContent';
import Utility from '../../../../Utility/Utility';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { loaderStateTrue, loaderStateFalse } from '../../../../Actions/AllAction';
import { setUserCredentials } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import LazyImage from '../../../../Utility/Components/LazyImageComponent';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function RoomTypeDetailsModalContent(props) {
    // console.log("props.roomTypeDetailsData.room_type_images===========", props.roomTypeDetailsData)
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef(null);
    const slider2 = useRef(null);

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
    }, []);

    const rawImages = props.roomTypeDetailsData.room_type_images ?? [];

    const images = rawImages.filter(
        (item, index, self) =>
            index ===
            self.findIndex(
                (t) =>
                    t.image_url === item.image_url
            )
    );
    return (
        <>
            <div className="innerBodySection">
                <div className='col-md-12'>
                    <div className='row'>
                        <div className='col-md-7'>
                            {images.length > 0 && (
                                <div className="col-sm-12 img-caro">
                                    <Slider
                                        asNavFor={nav2}
                                        ref={slider1}
                                        arrows={false}
                                        infinite={images.length > 1}
                                        slidesToShow={1}
                                        swipeToSlide={true}
                                        lazyLoad="ondemand"
                                        className="main-slider"
                                    >
                                        {images.map((imageValue, index) => {
                                            const imgUrl =
                                                imageValue.image_url !== ""
                                                    ? JSON.parse(imageValue.image_url).img_url
                                                    : require("../../../../Utility/Public/images/no-icon1.png");

                                            return (
                                                <div key={index} className="carousel-main-item">
                                                    <LazyImage
                                                        src={imgUrl}
                                                        alt={"room image"}
                                                        loaderImage={require("../../../../Utility/Public/images/no-icon1.png")}
                                                        className="carouselImgpic"
                                                    />
                                                </div>
                                            );
                                        })}
                                    </Slider>

                                    <Slider
                                        asNavFor={nav1}
                                        ref={slider2}
                                        slidesToShow={5}
                                        swipeToSlide={true}
                                        focusOnSelect={true}
                                        arrows={false}
                                        infinite={images.length > 1}
                                        centerMode={false}
                                        className="thumb-slider mt-2"
                                    >
                                        {images.map((imageValue, index) => {
                                            const imgUrl =
                                                imageValue.image_url !== ""
                                                    ? JSON.parse(imageValue.image_url).img_url
                                                    : require("../../../../Utility/Public/images/no-icon1.png");

                                            return (
                                                <div key={index} className="carousel-thumb-item">
                                                    <LazyImage
                                                        src={imgUrl}
                                                        alt={"room thumbnail"}
                                                        loaderImage={require("../../../../Utility/Public/images/no-icon1.png")}
                                                        className="carouselThumbpic"
                                                    />
                                                </div>
                                            );
                                        })}
                                    </Slider>
                                </div>
                            )}
                        </div>
                        <div className='col-md-5'>
                            {Array.isArray(props.roomTypeDetailsData?.room_type_facility) && props.roomTypeDetailsData.room_type_facility.length > 0 && (
                                <div className='media-right-side amenitiesBox'>
                                    <h6 className='popular-facilities'>Most popular facilities</h6>
                                    <ul>
                                        {props.roomTypeDetailsData.room_type_facility.map((facilityItem, index) => {
                                            const facilityData = facilityItem.RoomTypeFacilityRelationData;
                                            const imgUrl = facilityData?.logo_url && facilityData.logo_url !== ""
                                                ? JSON.parse(facilityData.logo_url).img_url
                                                : require('../../../../Utility/Public/images/no-icon1.png');

                                            return (
                                                <li key={index}>
                                                    <span>
                                                        <LazyImage
                                                            src={imgUrl}
                                                            alt={facilityData?.facility_name || "Facility"}
                                                            loaderImage={require('../../../../Utility/Public/images/no-icon1.png')}
                                                            className="facilityIcon"
                                                        />
                                                        {facilityData?.facility_name || "Facility"}
                                                    </span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>
            <div className="col-md-12 submitSuccessBtn">
                <button className="btn submitBtn" onClick={props.closeRoomTypeDetailsModal}>Close</button>
            </div>
        </>
    );
}

RoomTypeDetailsModalContent.defaultProps = {
    isEdit: false
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials })(withRouter(RoomTypeDetailsModalContent));

